import { render, staticRenderFns } from "./InspectionFinalDocumentsAttachModal.vue?vue&type=template&id=0cc268f4&"
import script from "./InspectionFinalDocumentsAttachModal.vue?vue&type=script&lang=js&"
export * from "./InspectionFinalDocumentsAttachModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports